import React from 'react';
import classNames from 'classnames';
import { ListingContactType } from 'models/Listing';
import ResolveImage from 'components/ResolveImage';

import './ListingContactsCardList.styles.scss';

type ListingContactsCardListProps = {
  className?: string;
  listingContacts: Array<ListingContactType>;
};

const ListingContactsCardList: React.FC<ListingContactsCardListProps> = (
  props,
) => {
  const { listingContacts = [], className } = props;

  const classes = classNames('listing-contacts-card-list', className);

  const shownContact = listingContacts[0];

  if (!shownContact || !shownContact.name) return null;

  return (
    <div className={classes}>
      <div className="left-content">
        <ResolveImage
          asAvatar
          src={shownContact.brokerImage?.url}
          shouldLazyLoad={false}
        />
        <span>{shownContact.name}</span>
        {shownContact.position && <span>{shownContact?.position}</span>}
      </div>
    </div>
  );
};

export default ListingContactsCardList;
